<template>
  <div v-if="step > 1">
    <div class="input-group position-relative">
      <input
        class="form-control"
        v-model="localQuery"
        :placeholder="placeHolder"
        type="text">
      <i
        v-if="localQuery.length"
        class="fa fa-times text-danger query-times animate__animated animate__fadeInRight animate__faster"
        @click="clear"/>
      <button class="btn btn-outline-light">
        <i class="fa fa-search"/>
      </button>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref, watch } from 'vue';
  import { useStore } from 'vuex';
  
  // Initialize
  const store = useStore()

  // Data
  const localQuery = ref('')

  // Methods
  const clear = ()=>{
    localQuery.value = ''
  }

  // Watchers
  watch(localQuery, async()=>{
    if(step.value == 2){
      store.dispatch('dropshipUpdateQuery', localQuery)
    }
    if(step.value == 3){
      store.dispatch('setSubSearch', localQuery)
    }
  })

  // Computed
  const step = computed(()=>{
    return store.getters.dropshipStep
  })

  const placeHolder = computed(()=>{
    switch(step.value){
      case 2:
        return 'Search Manufacturers...'
      case 3:
        return 'Search Products...'
    }
  })
  
</script>

<style scoped>
  .query-times{
    position: absolute;
    top: 11px;
    right: 3em;
    z-index: 5;
    cursor: pointer;
  }
</style>